module.exports = __webpack_public_path__ + "img/d_xac.191bb512.jpg";